/* eslint-disable */
import { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
// import _ from 'lodash';
import { Button, Tooltip } from '@mui/material';
import { Filter, RefreshCcw, TrainFrontTunnel, Upload } from 'lucide-react';
import styles from './MyAuditsPage.module.scss';
import { BackdropLoader } from '../../../Components/Loaders';
import ListTable from '../../../Components/ListTable/ListTable';
import { notificationServices } from '../../../Services';
import {
	classes,
	filtersInfoChip,
	getActionColumn,
	getFileName,
	handleResponseStreamDownload,
} from '../../../Helpers';
import ImagesFinder from '../../../Components/ImagesFinder/ImagesFinder';
import auditServices from '../../../Services/audit-services';
import processAuditServices from '../../../Services/processAudit-services';
import assetAuditServices from '../../../Services/assetAudit-services';
import processFlowServices from '../../../Services/Analytics Services/process-flow.services';
import { AuditItemsModal } from '../../../Components/Modals/AuditItemsModal';
import AuditCreationModal from '../../../Components/Modals/AuditCreationModal/AuditCreationModal';
import ProcessAuditCreationModal from '../../../Components/Modals/ProcessAuditCreationModal/ProcessAuditCreationModal';
import AssetAuditCreationModal from '../../../Components/Modals/AssetAuditCreationModal/AssetAuditCreationModal';
import AssetAuditReportModal from '../../../Components/Modals/AssetAuditReportModal/AssetAuditReportModal';
import UploadDataModal from '../../../Components/Modals/UploadDataModal/UploadDataModal';
import excel from '../../../Images/excel.svg';
import { formActions, modalActions } from '@/Actions';
import { useAuth } from '@/Components/Auth/Login/auth';
import drawerActions from '@/Actions/drawer.actions';
import GlobalSearch from '@/Components/globalSearch/search';

const SwitchTab = ({ options = [], onTabChange, activeTabName = '' }) => {
	const [activeTab, setActiveTab] = useState(activeTabName);

	useEffect(() => {
		setActiveTab(activeTabName);
	}, [activeTabName]);

	const handleTabClick = (tab) => {
		setActiveTab(tab);
		if (onTabChange) onTabChange(tab);
	};

	return (
		<div className='flex justify-start p-1 bg-yellow-100 rounded-lg w-fit'>
			{options.map((option) => (
				<button
					key={option}
					type='button'
					className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${activeTab === option
							? 'bg-[#ffb703] shadow text-white'
							: 'text-yellow-800 hover:text-yellow-900'
						}`}
					onClick={() => handleTabClick(option)}
				>
					{option}
				</button>
			))}
		</div>
	);
};

const TABLE_COLUMNS = [
	{
		title: 'Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Comment',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expected Stock',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Final Audit Count',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Wastage',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Dispatched',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created At / Activated At',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Last Action By',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'Scheduled/Start',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Scanning Completed At',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Stock Adjustment At',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Bulk Action',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	Id: 'id',
	Name: 'name',
	Type: 'subType',
	Comment: 'closeComment',
	'Created At / Activated At': 'id',
	Start: 'startDate',
	'Scanning Completed At': 'endDate',
	'Stock Adjustment At': 'stockAdjustmentAt',
	'Store Name': 'storeName',
	Status: 'id',
	'Expected Stock': 'auditStatus.total',
	'Final Audit Count': 'auditStatus.audited',
	Wastage: 'auditStatus.wastage',
	Dispatched: 'auditStatus.dispatched',
	'Created By': 'createdByName',
	'Last Action By': 'lastActionByName',
	'Bulk Action': 'id',
};

const statusList = [
	{
		id: 'COMPLETED',
		title: 'COMPLETED',
	},
	{
		id: 'ACTIVE',
		title: 'ACTIVE',
	},
	{
		id: 'SCHEDULED',
		title: 'SCHEDULED',
	},
	{
		id: 'CLOSED',
		title: 'SCANNING DONE',
	},
	{
		id: 'CANCELLED',
		title: 'CANCELLED',
	},
];

function MyAuditsPage(props) {
	const {
		toggleModal,
		toggleAuditCreationModal,
		toggleProcessAuditCreationModal,
		toggleAssetAuditCreationModal,
		toggleAlert,
		fetchProducts,
		productsList,
		showUploadDataModal,
		payload,
		toggleUploadDataModal,
		toggleFiltersDrawer,
		storesList,
	} = props;

	const [isLoading, setIsLoading] = useState(false);
	const [auditsList, setAuditList] = useState([]);
	const [auditType, setAuditType] = useState('Store Audit');
	const isProcess = auditType === 'Process Audit';
	const isAsset = auditType === 'Asset Audit';
	// AssetAuditStatus has no SCHEDULED member — filtering on it makes the
	// backend raise "Invalid status filter".
	const assetStatusList = statusList.filter((ele) => ele.id !== 'SCHEDULED');
	// The row being viewed on the Asset Audit tab. Local state, not redux:
	// the whole audit (including its reports) is already in hand from the
	// list response, so the modal needs no store of its own.
	const [assetAuditToView, setAssetAuditToView] = useState(null);
	const [processList, setProcessList] = useState([]);
	const [filters, setFilters] = useState({
		store: null,
		dateRange: {
			from: moment(new Date())?.format('YYYY-MM-DD'),
			to: moment(new Date())?.format('YYYY-MM-DD'),
		},
		type: null,
		status: null,
	});
	const [search, setSearch] = useState('');
	const [selectedOption, setSelectedOption] = useState(null);
	const [isRefresh, setIsRefresh] = useState(false);
	const exportFilters = useRef();
	const { userConfig = {}, appConfig = {} } = useAuth();
	const { userDetails = {}, userRoles = {} } = userConfig || {};
	const { level } = userDetails || {};
	const isBakingoCustomer = appConfig?.customerId === 0;
	const levels = [1];

	const BASE_COLUMNS = [
		{
			title: 'View',
			config: {
				type: 'VIEW',
			},
		},
	];

	const ADDITIONAL_COLUMNS = [
		{
			title: 'Action',
			config: {
				type: 'CLOSE',
			},
		},
	];

	useEffect(() => {
		fetchProducts({
			entity: 'ALL_PRODUCTS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	useEffect(() => {
		if (isProcess) {
			(async () => {
				try {
					const resp = await processFlowServices.fetchAvailableNodes();
					setProcessList(resp?.data ?? resp ?? []);
				} catch (e) {
					setProcessList([]);
				}
			})();
		}
	}, [isProcess]);

	const fetchStoreAudits = async (request, isRefresh = false) => {
		setIsRefresh(isRefresh);
		if (Object.keys(request ?? {})?.length === 0) {
			request = {
				store: filters?.store?.id,
				dateRange: {
					from: filters?.dateRange?.from,
					to: filters?.dateRange?.to,
				},
				status: filters?.status,
			};
		} else {
			setFilters({
				store: request?.store,
				dateRange: {
					from: moment(request?.dateRange?.from)?.format(
						'YYYY-MM-DD'
					),
					to: moment(request?.dateRange?.to)?.format('YYYY-MM-DD'),
				},
				status: request?.status,
				type: request?.type,
			});
		}
		const req = {
			data: {
				filters: {
					storeId: request?.store?.id,
					dateRangeFilter: {
						from: moment(request?.dateRange?.from)?.format(
							'YYYY-MM-DD'
						),
						to: moment(request?.dateRange?.to)?.format(
							'YYYY-MM-DD'
						),
					},
					type: request?.type,
					status: request?.status,
					auditId: isRefresh ? null : search ? Number(search) : null,
				},
			},
		};
		try {
			setIsLoading(true);
			const response = await auditServices?.fetchAuditList(req);
			if (response?.statusCode === 200) {
				setAuditList(
					response?.data?.map((ele) => {
						return {
							...ele,
							startDate: ele?.createdAt
								? moment(ele?.createdAt)?.format(
									'YYYY-MM-DD hh:mm:ss A'
								)
								: '-',
							endDate: ele?.closedAt
								? moment(ele?.closedAt)?.format(
									'YYYY-MM-DD hh:mm:ss A'
								)
								: '-',
						};
					})
				);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const fetchProcessAudits = async (request, isRefresh = false) => {
		setIsRefresh(isRefresh);
		// ImagesFinder's onSubmit hands us `processTypes` (the selected process object)
		// when filtersInfo.processType.show=true. Its shared deserializer (config.js)
		// always wraps the single-select id as a one-element array
		// (`{id: [filters.processTypes.id], ...}`), even though this picker is
		// single-select — so unwrap it here rather than sending a list to a backend
		// filter that does `int(filters["processId"])`.
		// When fetchProcessAudits is called from the search/refresh path with
		// `filters` state instead, it already has the (scalar) id under `processId`.
		const processTypesId = request?.processTypes?.id;
		const selectedProcessId = (Array.isArray(processTypesId) ? processTypesId[0] : processTypesId)
			?? request?.processId
			?? null;
		if (Object.keys(request ?? {}).length === 0) {
			// no-op; use existing filters
		} else {
			setFilters({
				store: request?.store,
				dateRange: {
					from: moment(request?.dateRange?.from)?.format('YYYY-MM-DD'),
					to: moment(request?.dateRange?.to)?.format('YYYY-MM-DD'),
				},
				status: request?.status,
				type: request?.type,
				processId: selectedProcessId,
			});
		}
		const req = {
			data: {
				filters: {
					storeId: request?.store?.id,
					processId: selectedProcessId,
					dateRange: {
						from: moment(request?.dateRange?.from)?.format('YYYY-MM-DD'),
						to: moment(request?.dateRange?.to)?.format('YYYY-MM-DD'),
					},
					status: request?.status,
				},
				limit: 50,
				offset: 0,
			},
		};
		try {
			setIsLoading(true);
			const response = await processAuditServices.fetchProcessAuditList(req);
			if (response?.statusCode === 200) {
				const rows = response?.data?.audits ?? [];
				setAuditList(
					rows.map((ele) => {
						// storeName + processName come from BE now (see
						// _buildAuditDisplayNameMaps in processAuditHandlers.py).
						// Fall back to '-' only if BE didn't supply them.
						return {
							...ele,
							storeName: ele.storeName ?? '-',
							processName: ele.processName ?? '-',
							startDate: ele.createdAt
								? moment(ele.createdAt).format('YYYY-MM-DD hh:mm:ss A')
								: '-',
							endDate: ele.closedAt
								? moment(ele.closedAt).format('YYYY-MM-DD hh:mm:ss A')
								: '-',
						};
					})
				);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	/**
	 * Asset audits list. Rows arrive pre-serialised from the backend
	 * dataclasses, so only the timestamps are reshaped for the table.
	 */
	const fetchAssetAudits = async (request, isRefresh = false) => {
		setIsRefresh(isRefresh);
		if (Object.keys(request ?? {}).length > 0) {
			setFilters({
				store: request?.store,
				dateRange: {
					from: moment(request?.dateRange?.from)?.format('YYYY-MM-DD'),
					to: moment(request?.dateRange?.to)?.format('YYYY-MM-DD'),
				},
				status: request?.status,
				type: request?.type,
			});
		}
		const req = {
			data: {
				filters: {
					storeId: request?.store?.id,
					dateRange: {
						from: moment(request?.dateRange?.from)?.format('YYYY-MM-DD'),
						to: moment(request?.dateRange?.to)?.format('YYYY-MM-DD'),
					},
					status: request?.status,
				},
			},
		};
		try {
			setIsLoading(true);
			const response = await assetAuditServices.fetchAssetAuditList(req);
			if (response?.statusCode === 200) {
				const rows = response?.data?.audits ?? [];
				setAuditList(
					rows.map((ele) => ({
						...ele,
						storeName: ele.storeName ?? '-',
						assetTypeCount: (ele.reports ?? []).length,
						startDate: ele.createdAt
							? moment(ele.createdAt).format('YYYY-MM-DD hh:mm:ss A')
							: '-',
						endDate: ele.closedAt
							? moment(ele.closedAt).format('YYYY-MM-DD hh:mm:ss A')
							: '-',
					}))
				);
			}
		} catch (error) {
			// handleResponse rejects AND toasts on a 300, so there is nothing
			// to add here beyond not swallowing it silently.
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const fetchAudits = (request, isRefresh = false) => {
		if (isProcess) return fetchProcessAudits(request, isRefresh);
		if (isAsset) return fetchAssetAudits(request, isRefresh);
		return fetchStoreAudits(request, isRefresh);
	};

	const handleAuditTabChange = (tab) => {
		setAuditType(tab);
		setSearch('');
	};

	const handleReOpenAudit = async (currItem) => {
		try {
			setIsLoading(true);
			const response = isProcess
				? await processAuditServices.transitionProcessAudit({
					data: { auditId: currItem.id, storeId: currItem.storeId, targetStatus: 'ACTIVE' },
				})
				: await auditServices?.reOpenAudit({
					data: { auditId: currItem?.id, storeId: currItem?.storeId },
				});
			if (response?.statusCode === 200) {
				fetchAudits();
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message ?? 'Some error occured',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message ?? 'Some error occured',
			});
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleViewClick = async (currItem, disabled) => {
		console.log(currItem, 'currItem');
		const req = {
			data: {
				auditId: currItem?.id,
			},
		};
		try {
			setIsLoading(true);
			const response = isProcess
				? await processAuditServices.fetchProcessAuditReview(req)
				: await auditServices?.fetchAuditItems(req);
			console.log(currItem, 'currItem');
			if (response?.statusCode === 200) {
				const storeObj = storesList?.find(
					(s) => s?.id === currItem?.storeId
				);
				toggleModal(true, {
					items: response?.data?.reports ?? response?.data?.report,
					auditId: currItem?.id,
					storeId: currItem?.storeId,
					storeSubType: storeObj?.subType,
					isDisabled: disabled,
					hideButtons: disabled,
					showInitiatedAuditItems: currItem?.status === 'SCHEDULED',
				});
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};
	const handleScheduledViewClick = async (currItem) => {
		const req = {
			data: {
				auditId: currItem?.id,
			},
		};
		try {
			setIsLoading(true);
			const response = await auditServices?.fetchScheduledAuditItems(req);
			if (response?.statusCode === 200) {
				let selectedProducts = productsList;
				if (currItem?.productIds && currItem?.productIds?.length) {
					selectedProducts = currItem?.productIds?.map((ele) => {
						const product = productsList?.find((proItem) => {
							return proItem?.id === ele;
						});
						return product;
					});
				}
				toggleModal(true, {
					items: selectedProducts,
					categories: response?.data?.selectedCategories,
					skus: response?.data?.selectedSkus,
					auditId: currItem?.id,
					storeId: currItem?.storeId,
					storeName: currItem?.storeName,
					isDisabled: true,
					hideButtons: true,
					showGeneralDetails: true,
					showInitiatedAuditItems: currItem?.status === 'SCHEDULED',
				});
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const onViewClick = (currItem) => {
		if (isAsset) {
			setAssetAuditToView(currItem);
			return;
		}
		if (currItem?.status === 'SCHEDULED') {
			handleScheduledViewClick(currItem);
		} else {
			handleViewClick(currItem, true);
		}
	};

	const handleCancelAudit = async (currItem) => {
		try {
			setIsLoading(true);
			let response;
			if (isAsset) {
				response = await assetAuditServices.transitionAssetAudit({
					data: {
						auditId: currItem.id,
						storeId: currItem.storeId,
						targetStatus: 'CANCELLED',
					},
				});
			} else {
				response = isProcess
					? await processAuditServices.transitionProcessAudit({
						data: { auditId: currItem.id, storeId: currItem.storeId, targetStatus: 'CANCELLED' },
					})
					: await auditServices?.cancelAudit({
						data: { auditId: currItem?.id, storeId: currItem?.storeId, status: 'CANCELLED' },
					});
			}
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				fetchAudits(filters);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	// Asset audits have no adjustment step — completion applies exactly the
	// figures that were counted, so this goes straight to the transition.
	const handleCompleteAssetAudit = async (currItem) => {
		try {
			setIsLoading(true);
			const response = await assetAuditServices.transitionAssetAudit({
				data: {
					auditId: currItem?.id,
					storeId: currItem?.storeId,
					targetStatus: 'COMPLETED',
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				// Completion can succeed while still having something the
				// operator must know about: asset types nobody counted (their
				// stock was left alone) and stores that held fewer units than
				// this audit took from them. Silence here means finding out
				// from the ledger weeks later.
				showAssetCompletionWarnings(response?.data);
				fetchAudits(filters);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage ?? 'Some error occured',
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const showAssetCompletionWarnings = (data) => {
		const shortfalls = data?.debitShortfalls ?? [];
		if (!shortfalls.length) return;
		const LIST_CAP = 25;
		const message = (
			<div className='flex flex-col gap-2 text-left'>
				{shortfalls.length > 0 && (
					<div>
						<p className='font-semibold text-red-600'>
							{shortfalls.length}
							{' '}
							store/type pair(s) held fewer units than this audit
							took from them:
						</p>
						<ul className='list-disc pl-5 text-sm'>
							{shortfalls.slice(0, LIST_CAP).map((sf) => (
								<li key={`sf-${sf.storeId}-${sf.assetTypeId}`}>
									{`Store ${sf.storeId}`}
									{' — '}
									{sf.assetTypeName ?? `Asset Type ${sf.assetTypeId}`}
									{': took '}
									{sf.unitsAdopted}
									{', had '}
									{sf.ledgerHeld}
								</li>
							))}
						</ul>
						{shortfalls.length > LIST_CAP && (
							<p className='text-sm italic'>
								and
								{' '}
								{shortfalls.length - LIST_CAP}
								{' '}
								more.
							</p>
						)}
					</div>
				)}
			</div>
		);
		toggleAlert(true, {
			heading: 'Audit completed — with warnings',
			message,
			handleConfirm: () => toggleAlert(false),
			cancelText: 'Close',
			confirmText: 'Close',
		});
	};

	const handleExcelDownload = useCallback((header, fileData, fileName) => {
		const commonColumns = [];
		const downloadBtn = document.createElement('a');
		const csvData = [[...commonColumns, ...header], ...fileData];

		const csv = `${csvData
			.map((e) => {
				return e.join(',');
			})
			.join('\n ')}`;

		const encodedValue = new Blob([csv], {
			type: 'text/csv',
		});
		let newFileName = fileName.replaceAll(".", "-")
		downloadBtn.href = window.URL.createObjectURL(encodedValue);
		downloadBtn.target = '_blank';
		downloadBtn.download = newFileName;
		downloadBtn.click();
	}, []);

	const handleExportNonQrItems = async (data) => {
		const headers = [
			'Item Code',
			'UY Item Id',
			'Store Id',
			'Store Code',
			// 'Store Name',
			'Product Name',
			'Variant Name',
			'Last Price',
			'unit',
			'Current Stock',
		];
		const exportData = [];
		data?.items?.forEach((item) => {
			exportData.push([
				item?.clientVariantId,
				item?.variantId,
				data?.storeId,
				data?.clientStoreId,
				item?.productName,
				item?.variantName,
				item?.lastPrice,
				item?.unit,
				item?.currentStock,
			]);
		});
		handleExcelDownload(
			headers,
			exportData,
			`Audit Report of Non QR Items for ${data?.storeName}`
		);
	};

	/**
	 * Asset tab: the export is server-built (ticket 08's /typedCount/export
	 * returns an actual CSV file), unlike the store audit's fetch-then-
	 * client-build path below — so it streams straight through
	 * handleResponseStreamDownload instead of handleExportNonQrItems.
	 */
	const handleExportAssetTypedCounts = async (auditId, storeId) => {
		try {
			setIsLoading(true);
			const response = await assetAuditServices.exportTypedCounts({
				data: { auditId, storeId },
			});
			await handleResponseStreamDownload(
				response,
				`asset_audit_${auditId}_typed_counts_${moment().format('YYYY-MM-DD')}.csv`
			);
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error occured while exporting data',
			});
		} finally {
			setIsLoading(false);
		}
	};

	const handleExport = async (auditId, storeId) => {
		if (isAsset) {
			handleExportAssetTypedCounts(auditId, storeId);
			return;
		}
		try {
			setIsLoading(true);
			const req = {
				data: {
					auditId,
				},
			};
			const response = await auditServices.fetchNonQrItems(req);
			if (response?.statusCode === 200) {
				handleExportNonQrItems(response?.auditReport);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error occured while exporting data',
			});
		} finally {
			setIsLoading(false);
		}
	};

	/**
	 * Lists the rows a CSV import could not apply, so a bad row is SEEN and not
	 * just counted in a toast. Reuses the confirm-style AlertModal as a
	 * one-button info dialog.
	 */
	const showTypedCountImportIssues = (data) => {
		const errors = data?.errors ?? [];
		if (!errors.length) return;
		// A bad file can fail on every row. Show the first few and a count of
		// the rest, so the dialog stays readable.
		const ISSUE_LIST_CAP = 25;
		const shownErrors = errors.slice(0, ISSUE_LIST_CAP);
		const message = (
			<div className='flex flex-col gap-2 text-left'>
				{errors.length > 0 && (
					<div>
						<p className='font-semibold text-red-600'>
							{errors.length}
							{' '}
							row(s) could not be applied:
						</p>
						<ul className='list-disc pl-5 text-sm'>
							{shownErrors.map((e) => (
								<li key={`err-${e.row}-${e.assetTypeId}`}>
									Line
									{' '}
									{e.row}
									{': '}
									{e.assetTypeName ?? `Asset Type ${e.assetTypeId}`}
									{' — '}
									{e.error}
								</li>
							))}
						</ul>
						{errors.length > shownErrors.length && (
							<p className='text-sm italic'>
								and
								{' '}
								{errors.length - shownErrors.length}
								{' '}
								more — fix these first, then re-import.
							</p>
						)}
					</div>
				)}
			</div>
		);
		toggleAlert(true, {
			heading: 'Import result',
			message,
			handleConfirm: () => toggleAlert(false),
			cancelText: 'Close',
			confirmText: 'Close',
			colorReverse: true,
		});
	};

	const handleImportAssetTypedCounts = async (auditId, uploadFile, storeId) => {
		try {
			setIsLoading(true);
			const response = await assetAuditServices.importTypedCounts({
				data: {
					auditId,
					storeId,
					updatedAudit: uploadFile?.file,
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: response?.data?.errorCount ? 'warning' : 'success',
					message: response?.message,
				});
				showTypedCountImportIssues(response?.data);
				fetchAudits(filters);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage ?? response?.message,
				});
			}
		} catch (error) {
			// handleResponse already toasts a rejection's errorMessage; a
			// network/parse failure lands here with nothing toasted yet.
			if (typeof error !== 'string') {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occured while uploading data',
				});
			}
		} finally {
			setIsLoading(false);
		}
	};

	const handleImport = async (auditId, uploadFile, storeId) => {
		if (isAsset) {
			handleImportAssetTypedCounts(auditId, uploadFile, storeId);
			return;
		}
		try {
			setIsLoading(true);
			const req = {
				data: {
					auditId,
					updatedAudit: uploadFile?.file,
					storeId,
				},
			};
			const response = await auditServices.uploadNonQrItems(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error occured while uploading data',
			});
		} finally {
			setIsLoading(false);
		}
	};

	const uploadAuditReport = (auditId, storeId) => {
		toggleUploadDataModal(true, {
			heading: isAsset
				? 'Upload Non-Traceable Asset Types'
				: 'Upload Audit Report of Non QR Items',
			auditId,
			storeId,
		});
	};

	const SPECIAL_ITEMS = {
		Type: (_, obj) => {
			return obj?.subType?.split('_')?.join(' ') ?? 'AUDIT';
		},
		'Created At / Activated At': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			return moment(currItem?.createdAt).format('YYYY-MM-DD hh:mm A');
		},
		'Scheduled/Start': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			if (!currItem?.scheduledAt && !currItem?.startDate) return '-';
			if (currItem?.scheduledAt) {
				return moment(new Date(currItem?.scheduledAt)).format(
					'YYYY-MM-DD hh:mm A'
				);
			}
			return currItem?.startDate;
		},
		'Scanning Completed At': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className={styles['edit-container']}>
					<p>{currItem?.endDate ?? '-'}</p>
				</div>
			);
		},
		'Stock Adjustment At': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className={styles['edit-container']}>
					<p>
						{currItem?.stockAdjustmentAt
							? moment(
								new Date(currItem?.stockAdjustmentAt)
							).format('YYYY-MM-DD hh:mm A')
							: '-'}
					</p>
				</div>
			);
		},
		Status: (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			if (currItem?.status === 'CLOSED') {
				return 'SCANNING DONE';
			}
			return currItem?.status ?? '-';
		},
		'Store Name': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div
					style={{
						width: 125,
					}}
				>
					{currItem?.storeName}
				</div>
			);
		},
		'Process Name': (value, item) => {
			// Main-column signature: (cellValue, fullRow). ListTable calls
			// special[title](value, item) for columns in the `columns` prop
			// (vs (id, val) for `actions`). processName comes from BE
			// (_buildAuditDisplayNameMaps in processAuditHandlers.py).
			return (
				<div style={{ width: 125 }}>
					{value ?? item?.processName ?? '-'}
				</div>
			);
		},
		'Bulk Action': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			// const showImport = isInternal && userConfig?.userDetails?.level === 2;
			return (
				<div className='flex flex-col gap-2'>
					{(currItem?.status === 'CLOSED' ||
						currItem?.status === 'ACTIVE') && (
							<Button
								className='text-xs'
								variant='contained'
								color='primary'
								onClick={() =>
									handleExport(currItem.id, currItem.storeId)
								}
							>
								<div className='flex items-start justify-start gap-1 text-sx'>
									<img
										className='size-4'
										src={excel}
										alt='excel'
									/>
									{'Export Non QR'}
								</div>
							</Button>
						)}
					{/* Asset tab: import is refused server-side unless the audit
					    is ACTIVE — closing stops typed entry, and a CSV import
					    IS typed entry (ticket 09). Only offer the button then,
					    instead of letting the user hit the refusal. */}
					{(isAsset
						? currItem?.status === 'ACTIVE'
						: currItem?.status === 'CLOSED' || currItem?.status === 'ACTIVE') &&
						!levels.includes(level) && (
							<Button
								className='text-xs'
								variant='contained'
								color='primary'
								onClick={() =>
									uploadAuditReport(
										currItem.id,
										currItem.storeId
									)
								}
							>
								<div className='flex items-center justify-start gap-1 text-sx'>
									<Upload className='size-4' />
									{'Import Non QR'}
								</div>
							</Button>
						)}
				</div>
			);
		},
		Action: (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className={styles['action-btns']}>
					{/* Asset audits are one-way: once closed they cannot be
					    re-opened, so this Re-Open/Complete pair is for the
					    store and process tabs only. Assets get their own
					    Complete just below. */}
					{currItem?.status === 'CLOSED' && !isAsset && (
						<>
							<Button
								variant='contained'
								color='primary'
								className='flex items-center justify-center gap-1'
								onClick={() => {
									toggleAlert(true, {
										heading: 'Re-Open Audit',
										handleConfirm: () => {
											handleReOpenAudit(currItem);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you want to Re-Open Audit ${currItem?.id || ''
											}?`,
									});
								}}
							>
								<RefreshCcw className='size-4 mr-1' />
								Re-Open
							</Button>
							<Button
								variant='outlined'
								color='primary'
								onClick={() => {
									toggleAlert(true, {
										heading: 'Complete Audit',
										handleConfirm: () => {
											handleViewClick(
												currItem,
												currItem?.status !== 'CLOSED'
											);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you to Complete ${currItem?.id || ''
											}?`,
									});
								}}
							>
								Complete
							</Button>
						</>
					)}
					{/* Asset audits get Complete but never Re-Open, and it
					    applies the counted figures to asset stock — which
					    cannot be undone, so the confirmation says so. */}
					{currItem?.status === 'CLOSED' && isAsset && (
						<Button
							variant='contained'
							color='primary'
							onClick={() => {
								toggleAlert(true, {
									heading: 'Complete Audit',
									handleConfirm: () => {
										handleCompleteAssetAudit(currItem);
										toggleAlert(false);
									},
									colorReverse: false,
									cancelText: 'No',
									confirmText: 'Yes',
									message: `Complete audit ${currItem?.id || ''
										}? The counted figures will be applied to asset stock. This cannot be undone.`,
								});
							}}
						>
							Complete
						</Button>
					)}
					{!currItem?.status?.includes('COMPLETED') &&
						currItem?.status !== 'CANCELLED' && (
							<Button
								variant='outlined'
								color='error'
								onClick={() => {
									toggleAlert(true, {
										heading: 'Cancel Audit',
										handleConfirm: () => {
											handleCancelAudit(currItem);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you to Cancel ${currItem?.id || ''
											}?`,
									});
								}}
							>
								Cancel
							</Button>
						)}
				</div>
			);
		},
	};

	// eslint-disable-next-line func-names
	const rowColor = function (status) {
		switch (status) {
			case 'ACTIVE':
				return styles.active;
			case 'COMPLETED':
			case 'COMPLETED - Stocking Out':
				return styles.complete;
			case 'CANCELLED':
				return styles.cancel;
			case 'SCHEDULED':
				return styles.scheduled;
			case 'CLOSED':
				return styles.done;
			default:
				return null;
		}
	};

	const handleAdjustStock = async (auditId, storeId, adjustments) => {
		try {
			let response;
			if (isProcess) {
				response = await processAuditServices.transitionProcessAudit({
					data: { auditId, storeId, targetStatus: 'COMPLETED', adjustments },
				});
			} else {
				response = await auditServices.closeAudit({
					data: { auditId, storeId, adjustments },
				});
			}
			if (response?.statusCode === 200) {
				fetchAudits(filters);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Success',
				});
				toggleModal(false, {});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error occured while adjusting stock',
			});
		}
	};

	const handleAddClick = () => {
		if (isProcess) {
			toggleProcessAuditCreationModal(true, {});
		} else if (isAsset) {
			toggleAssetAuditCreationModal(true, {});
		} else {
			toggleAuditCreationModal(true, {});
		}
	};

	/**
	 * One call creates one audit per selected store. The backend refuses the
	 * whole batch if any store fails a guard, so a 300 is shown verbatim —
	 * its message names the store and the reason.
	 */
	const handleConfirmAssetCreation = async (creationState) => {
		setIsLoading(true);
		const req = {
			data: {
				name: creationState?.name,
				storeIds: creationState?.storeIds,
				assetTypeIds: creationState?.assetTypeIds,
			},
		};
		try {
			const response = await assetAuditServices.createAssetAudit(req);
			if (response?.statusCode === 200) {
				fetchAudits(filters);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Success',
				});
				toggleAssetAuditCreationModal(false, {});
			}
		} catch (error) {
			// handleResponse already toasted anything the backend said — it
			// rejects with the message string. Anything else (network down,
			// an HTML 500) has toasted nothing, and silently leaving the
			// wizard open with the spinner cleared is the worst outcome.
			if (typeof error !== 'string') {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Could not start the audit. Please try again.',
				});
			}
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleConfirmCreation = async (auditCreationState) => {
		setIsLoading(true);
		const req = {
			data: {
				scheduled:
					auditCreationState?.scheduled !== 'NOW'
						? auditCreationState?.scheduled
						: null,
				storeIds: auditCreationState?.selectedStores,
				name: auditCreationState?.auditName,
				products: !auditCreationState?.isAllProduct
					? auditCreationState?.productsList
					: null,
				productSelection: auditCreationState?.productSelection,
				allProducts: auditCreationState?.isAllProduct,
			},
		};
		try {
			const response = await auditServices.createAudit(req);
			if (response?.statusCode === 200) {
				fetchAudits(filters);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Success',
				});
				toggleModal(false, {});
				toggleAuditCreationModal(false, {});
			} else if (response?.statusCode === 300) {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage,
				});
				// fetchAudits({
				// store: storeId,
				// dateRange: {
				// from: moment(
				// new Date().setDate(new Date().getDate() - 10)
				// )?.format('YYYY-MM-DD'),
				// to: moment(new Date())?.format('YYYY-MM-DD'),
				// },
				// });
				toggleAuditCreationModal(false, {});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleConfirmProcessCreation = async (creationState) => {
		setIsLoading(true);
		const req = {
			data: {
				storeId: creationState.storeId,
				processId: creationState.processId,
				name: creationState.auditName,
				products: creationState.isAllProduct ? null : creationState.productsList,
				productSelection: creationState.productSelection,
				allProducts: creationState.isAllProduct,
			},
		};
		try {
			const response = await processAuditServices.createProcessAudit(req);
			if (response?.statusCode === 200) {
				fetchAudits(filters);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Success',
				});
				toggleProcessAuditCreationModal(false, {});
			} else if (response?.statusCode === 300) {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage ?? response?.message,
				});
				toggleProcessAuditCreationModal(false, {});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleAuditExits = (storeId) => {
		setFilters({
			storeId,
			dateRange: {
				from: moment(new Date())?.format('YYYY-MM-DD'),
				to: moment(
					new Date().setDate(new Date().getDate() - 10)
				)?.format('YYYY-MM-DD'),
			},
		});
	};
	const handleOnUpdate = (finderFilters) => {
		const dateRange = {
			startDate: moment(finderFilters?.dateRange?.from).format(
				'YYYY-MM-DD'
			),
			endDate: moment(finderFilters?.dateRange?.to).format('YYYY-MM-DD'),
		};
		const req = {
			data: {
				filters: {
					storeId: finderFilters?.store,
					dateRangeFilter: {
						from: moment(finderFilters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(finderFilters?.dateRange?.to).format(
							'YYYY-MM-DD'
						),
					},
					status: finderFilters?.status,
					type: finderFilters?.type,
				},
			},
		};
		exportFilters.current = req.data.filters;
	};
	const handleExportData = async (filters) => {
		const exportFilters = {
			storeId: filters?.store?.id,
			dateRangeFilter: {
				from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
				to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
			},
			status: filters?.status,
			type: filters?.type,
		};
		const req = {
			data: exportFilters,
		};
		try {
			setIsLoading(true);
			// The store export (AUDIT_EXPORT) is a Java-service endpoint that
			// returns STORE audit rows, so the asset tab needs its own.
			const response = isAsset
				? await assetAuditServices.exportAssetAudits(req)
				: await auditServices?.auditExport(req);
			const fileName = isAsset
				? `asset_audits_${moment().format('YYYY-MM-DD')}.csv`
				: getFileName(exportFilters);
			handleResponseStreamDownload(response, fileName);
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Could not export. Please try again.',
			});
		} finally {
			setIsLoading(false);
		}
	};
	//  dropdown options
	const dropDownItems = [
		{
			label: 'Id',
			value: 'id',
			placeholder: 'Search by Audit ID',
			getData: true,
		},
		{
			label: 'Name',
			value: 'name',
			placeholder: 'Search by Audit Name',
			getData: false,
		},
	];

	// filtersInfo varies by tab:
	//   - Store Audit:  keeps the existing `type` filter (Audit / Day End).
	//   - Process Audit: replaces `type` with `processType` (single-process picker).
	// The ImagesFinder fetches process list itself via processFlowServices when
	// `processType.show=true` and a store is selected.
	//
	// Memoized on `isProcess` so the reference is stable across re-renders.
	// Without memoization, every MyAuditsPage render (e.g. when the creation
	// modal toggles via Redux) creates a new filtersInfo object, which
	// triggers ImagesFinder's filtersInfo-dependent effects (incl. fetchNodes)
	// to re-fire repeatedly.
	const filtersInfo = useMemo(() => {
		const baseFiltersInfo = {
			header: {
				store: false,
				date: false,
				statusAndTypes: false,
			},
			filteredStore: {
				text: 'Audits conducted at (Store)',
				show: true,
			},
			status: {
				text: 'Audit with status',
				show: true,
			},
			dateRangeOnly: {
				text: 'Scheduled Or Created At',
				show: true,
			},
		};
		if (isProcess) {
			return {
				...baseFiltersInfo,
				header: {
					...baseFiltersInfo.header,
					process: false,
				},
				processType: {
					text: 'Process',
					show: true,
				},
			};
		}
		// Asset audits have neither a process nor the store audit's
		// Audit/Day-End type split — store, status and date only.
		if (isAsset) {
			return baseFiltersInfo;
		}
		return {
			...baseFiltersInfo,
			type: {
				text: 'Audit Type',
				show: true,
				list: [
					{
						label: 'Audit',
						type: 'AUDIT',
					},
					{
						label: 'Day End',
						type: 'DAY_END',
					},
				],
			},
		};
	}, [isProcess, isAsset]);

	useEffect(() => {
		if (search === '') {
			fetchAudits(filters);
		}
		// `isProcess` is included so switching Audit/Process tabs triggers
		// a re-fetch through the same code path. `fetchAudits` dispatches
		// to the right service (store vs process) based on isProcess.
	}, [search, isProcess, isAsset]);

	// Memoized to give ImagesFinder a stable `defaultState` reference.
	// ImagesFinder has `useEffect(..., [defaultState])` that dispatches
	// SET_STORE / SET_DATE_RANGE on every change — passing a fresh inline
	// object on each parent render makes `store` state churn, which then
	// re-fires its fetchNodes effect (the /flow/nodes spam we saw).
	const imagesFinderDefaultState = useMemo(() => ({
		STORE: filters.store ?? { id: -999, name: '' },
		DATE_RANGE: {
			active: true,
			from: new Date(filters?.dateRange?.from),
			to: new Date(filters?.dateRange?.to),
		},
	}), [filters.store, filters?.dateRange?.from, filters?.dateRange?.to]);

	const handleCall = (e) => {
		if (e.key === 'Enter') {
			fetchAudits(filters);
		}
	};
	const exportInfo = {
		showExportBtn: true,
	};

	const processTableColumns = [
		{ title: 'Id', config: { type: 'DATA' } },
		{ title: 'Name', config: { type: 'DATA' } },
		{ title: 'Process Name', config: { type: 'DATA' } },
		{ title: 'Comment', config: { type: 'DATA' } },
		{ title: 'Status', config: { type: 'DATA' } },
		{ title: 'Created At / Activated At', config: { type: 'DATA' } },
		{ title: 'Created By', config: { type: 'DATA' } },
		{ title: 'Last Action By', config: { type: 'DATA' } },
	];

	const processSpecialColumns = [
		{ title: 'Scanning Completed At', config: { type: 'DATA' } },
		{ title: 'Stock Adjustment At', config: { type: 'DATA' } },
		{ title: 'Store Name', config: { type: 'DATA' } },
	];

	const assetTableColumns = [
		{ title: 'Id', config: { type: 'DATA' } },
		{ title: 'Name', config: { type: 'DATA' } },
		{ title: 'Asset Types', config: { type: 'DATA' } },
		{ title: 'Comment', config: { type: 'DATA' } },
		{ title: 'Status', config: { type: 'DATA' } },
		{ title: 'Created At / Activated At', config: { type: 'DATA' } },
		{ title: 'Created By', config: { type: 'DATA' } },
		{ title: 'Last Action By', config: { type: 'DATA' } },
	];

	// 'Store Name' sits here, not in assetTableColumns: SPECIAL_ITEMS['Store
	// Name'] looks the row up by id, which only holds on the actions calling
	// convention. Both other tabs do the same.
	const assetSpecialColumns = [
		{ title: 'Scanning Completed At', config: { type: 'DATA' } },
		{ title: 'Stock Adjustment At', config: { type: 'DATA' } },
		{ title: 'Store Name', config: { type: 'DATA' } },
		// Holds the Export/Import Typed Counts pair (tickets 08/09). Without
		// this column the buttons have nowhere to render on the asset tab.
		{ title: 'Bulk Action', config: { type: 'DATA' } },
	];

	const assetColMap = {
		Id: 'id',
		Name: 'name',
		Comment: 'closeComment',
		'Created At / Activated At': 'id',
		'Scanning Completed At': 'endDate',
		'Stock Adjustment At': 'stockAdjustmentAt',
		'Store Name': 'storeName',
		'Asset Types': 'assetTypeCount',
		Status: 'id',
		'Created By': 'createdByName',
		'Last Action By': 'lastActionByName',
		'Bulk Action': 'id',
		// SPECIAL_ITEMS.Action looks the row up by id, so it must map to 'id'
		// like the other tabs do.
		Action: 'id',
	};

	const processColMap = {
		Id: 'id',
		Name: 'name',
		Comment: 'closeComment',
		'Created At / Activated At': 'id',
		'Scanning Completed At': 'endDate',
		'Stock Adjustment At': 'stockAdjustmentAt',
		'Store Name': 'storeName',
		'Process Name': 'processName',
		Status: 'id',
		'Created By': 'createdByName',
		'Last Action By': 'lastActionByName',
	};

	return (
		<div className={styles.root}>
			<AuditItemsModal handleConfirm={handleAdjustStock} />
			<UploadDataModal
				show={showUploadDataModal}
				heading={payload?.heading}
				storeId={payload?.storeId}
				auditId={payload?.auditId}
				handleImport={handleImport}
			/>
			<AuditCreationModal
				handleConfirm={handleConfirmCreation}
				onAuditExists={handleAuditExits}
			/>
			<ProcessAuditCreationModal handleConfirm={handleConfirmProcessCreation} />
			<AssetAuditCreationModal handleConfirm={handleConfirmAssetCreation} />
			<AssetAuditReportModal
				audit={assetAuditToView}
				handleClose={() => setAssetAuditToView(null)}
			/>
			<BackdropLoader showProgress isLoading={isLoading} />
			<div>
				<div className='flex justify-between m-4 '>
					<span className='font-bold text-[16px]'>My Audits</span>
					{!levels.includes(level) && (
						<Button
							onClick={handleAddClick}
							className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
						>
							+ Start Audit
						</Button>
					)}
				</div>
				{!isBakingoCustomer && (
					<div className='px-4 pb-2'>
						<SwitchTab
							options={['Store Audit', 'Process Audit', 'Asset Audit']}
							activeTabName={auditType}
							onTabChange={handleAuditTabChange}
						/>
					</div>
				)}
				<ImagesFinder
					onSubmit={fetchAudits}
					statusList={isAsset ? assetStatusList : statusList}
					defaultState={imagesFinderDefaultState}
					filtersInfo={filtersInfo}
					exportInfo={exportInfo}
				/>
			</div>
			<div className='flex gap-4 w-full justify-start items-center py-1'>
				<div className='w-[81%]'>
					<GlobalSearch
						dropDownOptions={dropDownItems}
						setSearchValue={setSearch}
						handleValue={handleCall}
						setSelectedValue={setSelectedOption}
						isRefresh={isRefresh}
					/>
				</div>
				<div className=' flex justify-between items-center gap-3'>
					<Tooltip title='Refresh audits'>
						<RefreshCcw
							className='size-5 cursor-pointer'
							onClick={() => {
								fetchAudits(filters, true);
							}}
						/>
					</Tooltip>
					<Button
						onClick={() => {
							const filtersList = isProcess
								? ['STORE_FILTER', 'PROCESS_TYPE_FILTER', 'DATE_FILTER']
								: ['STORE_FILTER', 'DATE_FILTER'];
							toggleFiltersDrawer(true, {
								handleDataExport: (filters) =>
									handleExportData(filters),
								filters: filtersList,
							});
						}}
						className='flex items-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter and Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className={styles['table-container']}>
				<ListTable
					colMap={(() => {
						if (isProcess) return processColMap;
						if (isAsset) return assetColMap;
						return COLMAP;
					})()}
					columns={(() => {
						if (isProcess) return processTableColumns;
						if (isAsset) return assetTableColumns;
						return TABLE_COLUMNS;
					})()}
					data={auditsList
						?.filter((item) =>
							search && selectedOption?.value === 'name'
								? item.name &&
								item.name
									.toLowerCase()
									.includes(search.toLowerCase())
								: true
						)
						?.map((ele) => ({
							...ele,
							rowStyles: classes(
								styles.listItem,
								rowColor(ele?.status)
							),
						}))}
					actions={(() => {
						if (isProcess) {
							return [...processSpecialColumns, ...getActionColumn(BASE_COLUMNS, ADDITIONAL_COLUMNS, level)];
						}
						if (isAsset) {
							// Same View + Action cell as the other tabs. The
							// Action renderer offers only Cancel here: an asset
							// audit cannot be re-opened once closed, and
							// Complete arrives with ticket 10.
							return [...assetSpecialColumns, ...getActionColumn(BASE_COLUMNS, ADDITIONAL_COLUMNS, level)];
						}
						return [...SPECIAL_COLUMNS, ...getActionColumn(BASE_COLUMNS, ADDITIONAL_COLUMNS, level)];
					})()}
					special={SPECIAL_ITEMS}
					handleViewClick={(currItem) => onViewClick(currItem)}
					fixedHeaderTop='0'
					showBtnContainer={false}
					allowExport={false}
					pageName={(() => {
						if (isProcess) return 'My Process Audits';
						if (isAsset) return 'My Asset Audits';
						return 'My Audits';
					})()}
				/>
			</div>
		</div>
	);
}
const mapStateToProps = (state) => {
	const { userPermissions, navState } = state.navigation;
	const { LIST: productsList } = state.form.ALL_PRODUCTS.data;
	const storesList = state.form.STORES?.data?.LIST ?? [];
	const { uploadDataModal } = state.modal;
	const showUploadDataModal = uploadDataModal?.show;
	const payload = uploadDataModal?.data;
	return {
		navState,
		userPermissions,
		productsList,
		storesList,
		showUploadDataModal,
		payload,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleAuditItemsModal,
	toggleAuditCreationModal: modalActions.toggleAuditCreationModal,
	toggleProcessAuditCreationModal: modalActions.toggleProcessAuditCreationModal,
	toggleAssetAuditCreationModal: modalActions.toggleAssetAuditCreationModal,
	toggleAlert: modalActions.toggleAlert,
	fetchProducts: formActions.gateway,
	toggleUploadDataModal: modalActions.toggleUploadDataModal,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAuditsPage);
